module.exports = __webpack_public_path__ + "static/oc-83c1fb774004cbd14b004435b1b99241.png";